// @ts-nocheck
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { CUSTOMER_NATIVE_MIN_CHROMIUM_VERSION } from '@/utilities/constant';
import { HAIRLINE } from '@/features/cti2/team/teamUi';

const VERDICT_STYLE = {
  ok: 'bg-success/10 text-success',
  partial: 'bg-warning/10 text-warning',
  unverified: 'bg-muted text-muted-foreground',
};

const BROWSERS = [
  {
    name: 'Google Chrome',
    verdict: 'ok',
    verdictLabel: 'Supported',
    steps: [
      ['Microphone permission', 'Allow microphone access for this site when prompted (or via the padlock icon in the address bar).'],
      ['Language pack', `Install the speech recognition language pack for the agent/customer language in use (Settings → Languages).`],
      ['Verify the pack', 'Open chrome://components, find "Speech Recognition On-Device Pack" (or per-language pack) and confirm it is up to date.'],
      ['Device emulation', 'Chrome DevTools device emulation can interfere with getUserMedia/track routing — disable it while testing transcription.'],
      ['Shortcuts', `Customer transcription requires Chrome ${CUSTOMER_NATIVE_MIN_CHROMIUM_VERSION}+ and reads the call's incoming (remote) audio track directly.`],
    ],
  },
];

export default function TranscriptionSetupModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] max-w-2xl overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Transcription setup</DialogTitle>
        </DialogHeader>

        <ul className="list-disc space-y-1 pl-5 text-sm text-foreground">
          <li>Agent transcription uses your microphone via the browser&apos;s built-in speech recognition — no extra setup beyond microphone permission and a language pack.</li>
          <li>
            Customer transcription reads the call&apos;s incoming audio track directly, which needs Chrome{' '}
            {CUSTOMER_NATIVE_MIN_CHROMIUM_VERSION}+ specifically; other Chromium browsers fall back to
            transcribing the microphone and are blocked automatically to avoid misattributing speech.
          </li>
        </ul>

        <div className={`rounded-md border bg-muted/30 px-3 py-2 text-xs text-muted-foreground ${HAIRLINE}`}>
          Applies to every browser window/profile used for taking calls — permissions and language packs are
          scoped per browser profile, not per site.
        </div>

        <div className="space-y-3">
          {BROWSERS.map((browser) => (
            <div key={browser.name} className={`rounded-lg border p-3 ${HAIRLINE}`}>
              <div className="mb-2 flex items-center gap-2">
                <span className="text-sm font-semibold text-foreground">{browser.name}</span>
                <span className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${VERDICT_STYLE[browser.verdict]}`}>
                  {browser.verdictLabel}
                </span>
              </div>
              <dl className="space-y-1.5">
                {browser.steps.map(([label, detail]) => (
                  <div key={label} className="text-xs">
                    <dt className="font-medium text-foreground">{label}</dt>
                    <dd className="text-muted-foreground">{detail}</dd>
                  </div>
                ))}
              </dl>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
